(ns practitest.frontend.common.mixpanel
  (:require [re-frame.core :as re-frame]
            [practitest.frontend.subs :as subs]))

(defn entity-type->mixpanel
  [entity-type]
  (case entity-type
    :testset
    "TestSet"

    :test
    "Test"

    :test-step
    "Test Step"

    :requirement
    "Requirement"

    :milestone
    "Milestone"

    :issue
    "Issue"

    :instance
    "Instance"

    ;;else
    (str "Unknown-" entity-type)))

;; TODO: bundle mixpanel with app via npm ?

(defn track
  ([event-name]
   (track event-name {}))
  ([event-name properties]
   (when (exists? js/mixpanel)
     (let [account-id @(re-frame/subscribe [::subs/pt-datacenter-account])
           ;; merge default map and supplied params
           properties (merge {"account_id" account-id}
                             properties)]
       (js/mixpanel.track event-name (clj->js properties))))))

(re-frame/reg-fx
  ::track
  (fn [[event-name properties]]
    (track event-name properties)))
